import React, { useContext } from "react";
import Select from "react-select";
import { labels } from "../../../localization/labels";
import { constants } from "../../../utils/Constants";
import SecurityUtil from "../../../utils/SecurityUtils";
import { AppContext } from "../../domain/App/AppContext";

const genderOptions = [
  { value: constants.GENDER_MALE, label: labels.male },
  { value: constants.GENDER_FEMALE, label: labels.female }
];
const relationshipOptions = [
  {
    value: constants.RELATIONSHIP_STATUS_SINGLE,
    label: labels.relationShipStatusSingle
  },
  {
    value: constants.RELATIONSHIP_STATUS_TAKEN,
    label: labels.relationShipStatusTaken
  },
  {
    value: constants.RELATIONSHIP_STATUS_COMPLICATED,
    label: labels.relationShipStatusComplicated
  }
];

const customStyles = {
  menu: styles => ({ ...styles, zIndex: 1000 }),
  control: (styles, { isDisabled }) => ({
    ...styles,
    cursor: isDisabled ? "not-allowed" : "default",
    "pointer-events": isDisabled ? "initial" : "all",
    "background-color": isDisabled ? "var(--disabled-color)" : "white",
    "border-color": isDisabled ? "var(--disabled-border-color)" : "",
    color: isDisabled ? "var(--disabled-font-color)" : ""
  }),
  input: (styles, { isDisabled }) => ({
    ...styles,
    color: isDisabled ? "var(--disabled-font-color)" : ""
  }),
  singleValue: (styles, { isDisabled }) => ({
    ...styles,
    color: isDisabled ? "var(--disabled-font-color)" : ""
  }),
  placeholder: (styles, { isDisabled }) => ({
    ...styles,
    color: isDisabled ? "var(--disabled-font-color)" : ""
  })
};

const multiValueStyle = {
  multiValue: (styles, { data }) => {
    return {
      ...styles,
      backgroundColor: "#459fff"
    };
  },
  multiValueLabel: (styles, { data }) => ({
    ...styles,
    color: "white"
  }),
  multiValueRemove: (styles, { data }) => ({
    ...styles,
    color: "white",
    ":hover": {
      backgroundColor: "#007bff",
      color: "white"
    }
  })
};

const getVariantOptions = (options, variant) => {
  switch (variant) {
    case "gender":
      options = genderOptions;
      break;
    case "relationshipStatus":
      options = relationshipOptions;
      break;
    default:
      break;
  }

  return options;
};

const getSelectedValue = (value, options, isMulti) => {
  var selectedValue;

  if (value) {
    if (isMulti) {
      selectedValue = [];
      for (let i = 0; i < options.length; i++) {
        for (let j = 0; j < value.length; j++) {
          if (options[i].value.id === value[j].id) {
            selectedValue.push(options[i]);
          }
        }
      }
    } else {
      for (let i = 0; i < options.length; i++) {
        if (options[i].value.id === value.id) {
          selectedValue = options[i];
        }
      }
    }
  } else {
    selectedValue = 0;
  }

  return selectedValue;
};

const DropDown = props => {
  let propsOptions = props.options;
  let variant = props.variant;
  let value = props.value;

  if (propsOptions && value) {
    let valueExists = false;
    propsOptions.forEach(element => {
      if (element.value.id === value.id) {
        valueExists = true;
      }
    });
    if (!valueExists) {
      const option = {
        value: value,
        label: value.name
      };
      propsOptions.push(option);
    }
  }

  const options = getVariantOptions(propsOptions, variant);
  const selectedValue = getSelectedValue(value, propsOptions, props.isMulti);

  const onChange = selectedOption => {
    if (props.isMulti) {
      let options = [];
      if (selectedOption) {
        options = selectedOption.map(item => item.value);
      }
      props.onChange({
        target: { id: props.targetId, value: options }
      });
    } else {
      const selected = selectedOption ? selectedOption.value : undefined;
      props.onChange({
        target: {
          id: props.targetId,
          value: selected
        }
      });
    }
  };

  const userHasAnyOfProcessesOrSameParty = SecurityUtil.userHasAnyOfProcessesOrSameParty(
    props.processes,
    props.partyId
  );
  let styles;
  if (props.styles) {
    styles = props.styles;
  } else if (props.isMulti) {
    styles = multiValueStyle;
  }

  const inProgress = useContext(AppContext).promiseInProgress;

  return (
    <Select
      className={`drop-down ${props.required && !props.value ? "error" : ""}`}
      isSearchable={props.isSearchable}
      isDisabled={
        props.disabled ||
        inProgress ||
        !userHasAnyOfProcessesOrSameParty ||
        props.readOnly
      }
      isClearable={props.isClearable}
      onChange={onChange}
      options={options}
      placeholder={props.placeholder}
      value={selectedValue}
      getOptionLabel={props.getOptionLabel}
      isMulti={props.isMulti}
      styles={{ ...styles, ...customStyles }}
      menuPlacement="auto"
    />
  );
};

export default DropDown;
